import { createRequestHelper } from '@utils/swr'
import { type PaymentTransactionResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'
import { type PaymentOrderHash } from '../types/dataModel/eCommercePayments'

const { useRequest } = createRequestHelper<FortuneApis['get']['paymentTransaction'], PaymentTransactionResponse, { orderHash: PaymentOrderHash }>({
  client: 'fortuneGuest',
  key: params => params?.orderHash ? `/payment_transactions/${params.orderHash}` : null,
})

export const useApiGetGuestPaymentTransactionRequest = useRequest
